<template>
<div>
<ContentHeader :title="$store.state.languages.lang_phrases.yeni_proje_periyodu"  url="ProjectPeriods" :show_button="true"  icon="arrow-left" buttontype="danger" :label="$store.state.languages.lang_phrases.geri_don"></ContentHeader>


<form @submit.prevent="submitForm" class="mt-4">
<div class="grid">
<div class="col-12">
<InputTextValidate :data="fields[0]" :fieldindex="0" @emitValue="inputValueEmitted"></InputTextValidate>
</div>



<div class="col-12 " >
<InputCalendarValidate :data="fields[2]" :fieldindex="2" @emitValue="inputValueEmitted"></InputCalendarValidate>
</div> 

<div class="col-12 " v-if="!$store.state.projects.project.is_periodic">
<InputCalendarValidate :data="fields[3]" :fieldindex="3" @emitValue="inputValueEmitted"></InputCalendarValidate>
</div> 


<!--
<div class="col-12">
<InputSwitchValidate :data="fields[1]" :fieldindex="1" @emitValue="inputValueEmitted"></InputSwitchValidate>
</div>
-->
<template v-if="show_inputfields_selector">
<div class="col-12">
<Dropdown v-model="selected_flow" :options="flows" optionLabel="name" class=" p-inputtext-sm ml-2"   @change="flowSelected" :filter="true" />

<Dropdown v-if="selected_flow" v-model="selected_inputfield" :options="inputfields" optionLabel="name"  class=" p-inputtext-sm ml-2"   @change="inputfieldSelected" :filter="true" :loading="loading_inputfields" />

<Dropdown v-if="selected_inputfield && selected_inputfield.type=='columns'" v-model="selected_inputfieldcolumn" :options="columns" optionLabel="name"  class=" p-inputtext-sm ml-2"   @change="columnSelected" :filter="true" :loading="loading_columns" />
</div>
<br/>
<div class="col-12">
<div class="flex justify-content-end flex-wrap " v-if="ready_to_add_field">
 <Button label="Yeni Alan Ekle" class=" p-button-primary p-button-outlined  p-button-sm" @click="addInputfield"></Button>
</div>
</div>

<div class="col-12" v-if="included_inputfields.length">

<DataTable :value="included_inputfields" responsiveLayout="scroll" class="p-datatable-suppliers" >

<Column  header="Aşama">
<template #body="slotProps"> 
<p>{{slotProps.data.flow.name}}</p>
</template>
</Column>

<Column  header="Soru">
<template #body="slotProps"> 
<p>{{slotProps.data.inputfield.name}}</p>
</template>
</Column>

<Column  header="Sütun">
<template #body="slotProps"> 
<p v-if="slotProps.data.inputfieldcolumn">{{slotProps.data.inputfieldcolumn.name}}</p>
</template>
</Column>

<Column  header="">
<template #body="slotProps"> 
 <Button  icon="pi pi-trash" class=" p-button-danger p-button-outlined  p-button-sm" @click="removeFromList(slotProps.data.id)"></Button>
</template>
</Column>



</DataTable>

</div>



<div class="col-12">
  <hr>
</div>

</template>


</div>










<div class="flex justify-content-end flex-wrap mt-3">
 <Button label="Kaydet" class=" p-button-primary p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting" type="submit"></Button>
</div>



</form>


</div>
</template>

<script>
export default {

  name: 'CreateProjectPeriod',

  data () {
    return {   
      languages:[],
      fields:[
        {
          title:"İsim",
          key:"name",
          type:"text",
          value:null,
          min_length:2,
          max_length:1000,
          is_required:true,
          has_error:false,
          error_message:null,
          show:true,
        },
        {
          title:"Önceki Dönem Verisini Taşı",
          key:"copy_previous_data",
          type:"switch",
          value:false,
          show:true,
        },        
        {
          title:"Başlangıç Tarihi",
          key:"start_date",
          type:"date",
          value:null,
          is_required:true,
          show:true,
        },     
        {
          title:"Bitiş Tarihi",
          key:"end_date",
          type:"date",
          value:null,
          is_required:false,
          show:true,
        },
      ],
      show_inputfields_selector:false,
      flows:[],
      inputfields:[],
      columns:[],
      loading_inputfields:false,
      loading_columns:false,
      selected_flow:null,
      selected_inputfield:null,
      selected_inputfieldcolumn:null,
      included_inputfields:[],
      ready_to_add_field:false,
    }
  },
  async mounted()
  {
    this.languages = await this.generalApiGetWithoutLoader("languages") 
    this.flows = await this.generalApiGetWithoutLoader("project_self_evaluation_flows/"+this.$route.params.id) 
  },
  methods:{
     submitForm()
    {

        let validated = this.validateForm(this.fields)
        if(!validated.has_error)
        {
          this.submit()
        }
        console.log(validated)
    },
    inputValueEmitted(data)
    { 
      this.fields[data.index].value = data.value 
      this.fields[data.index].has_error = false   
      if(data.index==1)  
      {
        if(data.value)
        {
          //this.show_inputfields_selector = true
        }
        else
        {
          //this.show_inputfields_selector= false
        }
      }
    },
    async flowSelected()
    {
      this.selected_inputfield = null
      this.selected_inputfieldcolumn = null
      this.ready_to_add_field = false
      console.log("flowSelected")
      console.log(this.selected_flow)
      this.loading_inputfields = true
      this.inputfields = await this.generalApiGetWithoutLoader("questionlists/all_inputfields/"+this.selected_flow.questionlist_id) 
      this.inputfields.unshift({id:"all",name:"Hepsi"})
      this.loading_inputfields = false
    },
    async inputfieldSelected()
    {
      if(this.selected_inputfield.id=="all")
      {
        this.getAllInputfields()
      }
      else
      {
          this.ready_to_add_field = false
          this.selected_inputfieldcolumn = null

          if(this.selected_inputfield.type=="columns")
          {
            this.loading_columns = true
            this.columns = await this.generalApiGetWithoutLoader("questionlists/inputfield/columns/"+this.selected_inputfield.id) 
            this.columns = this.columns.filter((item)=>{return item.type=="text" || item.type=="number"})
            this.columns.unshift({id:"all",name:"Hepsi"})
            console.log(this.columns)
            this.loading_columns = false
          }
          else
          {
            this.ready_to_add_field = true
          }
      }
      
      
    },
    async getAllInputfields()
    {
      let int = 1
      for(let inputfield of this.inputfields) 
      {
        if(inputfield.id !=="all")
        {
          //if column type
          if(inputfield.type=="columns")
          {
            let columns = await this.generalApiGetWithoutLoader("questionlists/inputfield/columns/"+inputfield.id) 
            if(columns.length)
            {
              for(let column of columns)
              {
                if(column.id!=="all")
                {
                  let obj = {
                    id:Math.floor(Date.now() / 10)+int,
                    flow:this.selected_flow,
                    inputfield_type:inputfield.type,
                    inputfield:inputfield,  
                    inputfieldcolumn:column
                  }
                  this.included_inputfields.push(obj)
                  int++
                }
                
              }
            }
          }
          //if column type
          else
          {
            let obj = {
              id:Math.floor(Date.now() / 10)+int,
              flow:this.selected_flow,
              inputfield_type:inputfield.type,
              inputfield:inputfield,        
            }
            this.included_inputfields.push(obj)
            int++
          }

        }
        
      }
      this.selected_flow = null
      this.selected_inputfield = null
      this.selected_inputfieldcolumn = null
      this.ready_to_add_field = false
    },
    columnSelected()
    {
      if(this.selected_inputfieldcolumn.id=="all")
      {
        let int = 1
        for(let column of this.columns)
        {
          if(column.id!=="all")
          {
              let obj = {
              id:Math.floor(Date.now() / 10)+int,
              flow:this.selected_flow,
              inputfield_type:this.selected_inputfield.type,
              inputfield:this.selected_inputfield,  
              inputfieldcolumn:column
            }
            this.included_inputfields.push(obj)
            int++
          }
          
        }
        this.selected_flow = null
        this.selected_inputfield = null
        this.selected_inputfieldcolumn = null
        this.ready_to_add_field = false
      }
      else
      {
        this.ready_to_add_field = true
      }
      
    },
    addInputfield()
    {
      let existing_one
      if(this.selected_inputfield.type=="columns")
      {
        existing_one = this.included_inputfields.find((item)=>{
          return item.inputfield.id == this.selected_inputfield.id && item.inputfieldcolumn.id == this.selected_inputfieldcolumn.id && item.flow.id == this.selected_flow.id
        })
      }
      else
      {
        existing_one = this.included_inputfields.find((item)=>{
          return item.inputfield.id == this.selected_inputfield.id &&  item.flow.id == this.selected_flow.id
        })
      }

      if(!existing_one)
      {
        let obj = {
          id:Math.floor(Date.now() / 10),
          flow:this.selected_flow,
          inputfield_type:this.selected_inputfield.type,
          inputfield:this.selected_inputfield,        
        }
        if(this.selected_inputfield.type=="columns")
        {
          obj.inputfieldcolumn=this.selected_inputfieldcolumn
        }
        console.log(obj)
        this.included_inputfields.push(obj)
      }
      else
      {
        this.showMessage("info","Bu öğe listede bulunuyor","")
      }
      
      this.selected_flow = null
      this.selected_inputfield = null
      this.selected_inputfieldcolumn = null
      this.ready_to_add_field = false

    },
    removeFromList(id)
    {
      this.included_inputfields = this.included_inputfields.filter((item)=>{return item.id !== id})
    },
    submit()
    {         
      let formdata = this.createFormData(JSON.parse(JSON.stringify(this.fields)))
      console.log(formdata)
      formdata.append("included_inputfields",JSON.stringify(this.included_inputfields))  
      formdata.append("project_id",this.$route.params.id)    
      //formdata.append("data",JSON.stringify(this.fields))
      this.generalSubmission(formdata,"projectperiod/store",this.afterSubmit)
    },
    afterSubmit(response)
    {
        console.log(response)
        if(response.status==400)
        {
            this.showerror = true
            this.errormessage = response.data.errors[0].message
        } 
        else
        {
          this.$router.push({ name: 'ProjectPeriod', params: { period_id:response.data.id } })
        }
      
    },
  }
};
</script>

<style lang="css" scoped>
</style>